import { render } from "./LeftRow.vue?vue&type=template&id=05293df8"
import script from "./LeftRow.vue?vue&type=script&lang=js"
export * from "./LeftRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/vshemyatin/phonebook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__